import { actionSpinnerClose, actionSpinnerOpen } from '@qadra/frontend-common/redux/actions';
import { call, takeEvery, put } from '@qadra/frontend-common/redux-saga';
import { ACTIVATE } from '../actions';
import { apiActivatePost } from '../api';

function* activate({ payload }) {
  try {
    yield put(actionSpinnerOpen());

    const { returnUrl, error } = yield call(apiActivatePost, payload);

    if (error) {
      yield put({
        type: ACTIVATE._ERROR,
        error,
      });
      yield put(actionSpinnerClose());
    } else {
      window.location.href = returnUrl || '';
    }
  } catch (error) {
    yield put({
      type: ACTIVATE._ERROR,
      error,
    });
    yield put(actionSpinnerClose());
  }
}

function* watchActivate() {
  yield takeEvery(ACTIVATE._REQUEST, activate);
}

const array = [watchActivate];
export default array;
